import { AppState } from "./../types";
import { useSelector, shallowEqual } from "react-redux";
import { IAppData } from "./../redux/reducers/appDataReducer";

export function useAppData<T>(appDataPropSelector: (state: IAppData) => T) {
  const appData = useSelector((state: AppState) => state.appData, shallowEqual);
  return appDataPropSelector(appData);
}
